import React, { useState, useEffect } from "react";
import { LineChart, Line,XAxis,YAxis,CartesianGrid,Tooltip,ResponsiveContainer, PieChart,Pie,Cell} from "recharts";
import {ArrowUp,ArrowDown, Calendar,Home,Star} from "lucide-react";
import { Package } from "lucide-react";
import { FaClipboardList } from "react-icons/fa";
import { TbCheckupList } from "react-icons/tb";
import { LuPcCase } from "react-icons/lu";
import axios from "axios";
import { BaseUrl } from "../App";

import { FadeLoader } from 'react-spinners';

const UserDashboard = () => {
  // const [loading, setIsLoaded] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const [ServiceCount, setServiceCount] = useState([]);
  const [ServiceCountAvailable, setServiceCountAvailable] = useState([]);
  const [staffId, setStaffId] = useState(null);
  const [AllBookingUserToday, setAllBookingUserToday] = useState([]);
  const [AllBookingUserFuture, setAllBookingUserFuture] = useState([]);
  const [AllBookingUser, setAllBookingUser] = useState([]);
  const [CompleteBookingUser, setCompleteBookingUser] = useState([]);
  const [AllServiceBooking, setAllServiceBooking] = useState([])
  const [COLORS, setCOLORS] = useState([]);
  const [setall,setPieData] = useState([]);
  const [serviceBreakdown, setServiceBreakdown] = useState([]);
  const [serviceHistoryData, setServiceHistoryData] = useState([
    { name: "Jan", value: 2 },
    { name: "Feb", value: 3 },
    { name: "Mar", value: 1 },
    { name: "Apr", value: 4 },
    { name: "May", value: 2 },
    { name: "Jun", value: 3 },
  ]);
  const generateColors = (numColors) => {
    const colors = [];
    
    for (let i = 0; i < numColors; i++) {
      // Use a HSL (Hue, Saturation, Lightness) color model for variety
      const hue = (i * (360 / numColors)) % 360; // Distribute hues evenly
      colors.push(`hsl(${hue}, 70%, 60%)`); // Adjust saturation and lightness as needed
    }
    return colors;
  };
   // Function to generate a single random color in HSL format
   const generateRandomColor = () => {
    const hue = Math.floor(Math.random() * 360); // Hue between 0 and 360
    const saturation = Math.floor(Math.random() * (100 - 60 + 1)) + 60; // Saturation between 60 and 100
    const lightness = Math.floor(Math.random() * (80 - 40 + 1)) + 40; // Lightness between 40 and 80
    return `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
  };

  const pieData = AllServiceBooking?.map((service, index) => ({
    name: service.title,
    value: parseInt(service.service_count), // Ensure value is a number
    color: "", // Placeholder, will be filled in below
  }));

  
  useEffect(() => {
    // Generate dynamic data for PieChart and serviceBreakdown
    if (AllServiceBooking.length > 0) {
      // Calculate total service count
      const totalServiceCount = AllServiceBooking.reduce(
        (sum, service) => sum + parseInt(service.service_count),
        0
      );

      // Generate dynamic colors
      const generatedColors = AllServiceBooking.map(() => generateRandomColor());
      setCOLORS(generatedColors);

      const generatedPieData = AllServiceBooking.map((service, index) => ({
        name: service.title,
        value: parseInt(service.service_count),
        color: generatedColors[index % generatedColors.length], // Ensure we have a color for each slice
      }));
      setPieData(generatedPieData);

      const generatedServiceBreakdown = AllServiceBooking.map(
        (service, index) => {
          const percentage =
            totalServiceCount > 0
              ? (parseInt(service.service_count) / totalServiceCount) * 100
              : 0;
          return {
            type: service.title,
            percentage: percentage.toFixed(1), // Format to 1 decimal place
          };
        }
      );
      setServiceBreakdown(generatedServiceBreakdown);
    }
  }, [AllServiceBooking]);

  const colors = generateColors(pieData.length);
   // Assign the colors to the pieData
   pieData.forEach((data, index) => {
    data.color = colors[index];
  });

  useEffect(() => {
    setIsLoaded(true);
  }, []); // Set isLoaded to true after data is fetched and processed

  useEffect(() => {
    const fetchServiceCount = async () => {
      setIsLoaded(true);

      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/dashboard.php`,
          { action: "servicecount" }
        );
        console.log(response.data); // Check the structure of the response data
        // Assuming the response contains data like `value` and `growth`
        setServiceCount(response.data.total_service_count); // Adjust this based on the response structure
      } catch (error) {
        console.error("Error fetching service count:", error);
      }  finally {
        setIsLoaded(false);
      }
  
    };

    fetchServiceCount();
  }, []);

  useEffect(() => {


    const staffIdFromLocalStorage = sessionStorage.getItem("userId");
    if (staffIdFromLocalStorage) {
      setStaffId(staffIdFromLocalStorage);
    }
    if (staffIdFromLocalStorage) {
      const fetchTotalBookingUser = async () => {
        setIsLoaded(true);

        try {
          const response = await axios.post(
            `${BaseUrl}/backend/api/dashboard.php`,
            {
              action: "totalBookingUser",
              client_id: staffIdFromLocalStorage,
            }
          );

          setAllBookingUser(response.data.total_bookings);
        } catch (error) {
          console.error("Error fetching upcoming bookings:", error);
        }  finally {
          setIsLoaded(false);
        }
    
      };

      fetchTotalBookingUser();
    }
    // const fetchTotalBookingUser = async () => {
    //   try {
    //     const response = await axios.post(
    //       `${BaseUrl}/backend/api/dashboard.php`,
    //       { action: "totalBookingUser" }
    //     );
    //     console.log(response.data); // Check the structure of the response data
    //     // Assuming the response contains data like `value` and `growth`
    //     setAllBookingUser(response.data.total_bookings); // Adjust this based on the response structure
    //   } catch (error) {
    //     console.error("Error fetching service count:", error);
    //   }
    // };

    // fetchTotalBookingUser();
  }, []);

  useEffect(() => {
    const fetchTotalCompleteBookingUser = async () => {
      setIsLoaded(true);

      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/dashboard.php`,
          { action: "totalBookingUserComplete" }
        );
        console.log(response.data); // Check the structure of the response data
        // Assuming the response contains data like `value` and `growth`
        setCompleteBookingUser(response.data.total_bookings_complete); // Adjust this based on the response structure
      } catch (error) {
        console.error("Error fetching service count:", error);
      }  finally {
        setIsLoaded(false);
      }
  
    };

    fetchTotalCompleteBookingUser();
  }, []);

  useEffect(() => {
    const fetchServiceCountAvailable = async () => {
      setIsLoaded(true);

      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/dashboard.php`,
          { action: "servicecount" }
        );
        console.log(response.data); // Check the structure of the response data
        // Assuming the response contains data like `value` and `growth`
        setServiceCountAvailable(response.data.total_enabled_service_count); // Adjust this based on the response structure
      } catch (error) {
        console.error("Error fetching service count:", error);
      }  finally {
        setIsLoaded(false);
      }
  
    };

    fetchServiceCountAvailable();
  }, []);

  useEffect(() => {
    const fetchServiceAllData = async () => {
      setIsLoaded(true);

      try {
        const response = await axios.post(`${BaseUrl}/backend/api/dashboard.php`, {
          action: "AllserviceCount",
        });
        console.log("API Response:", response.data);

        if (response.data && response.data.services) {
          // Assuming your API response has a 'services' array
          setAllServiceBooking(response.data.services);
        } else {
          console.error("Invalid API response structure.");
        }
      } catch (error) {
        console.error("Error fetching service count:", error);
      }  finally {
        setIsLoaded(false);
      }
  
    };

    fetchServiceAllData();
  }, []);


  useEffect(() => {
    setIsLoaded(true);

    // Retrieve staff_id from localStorage
    const staffIdFromLocalStorage = sessionStorage.getItem("userId");
    if (staffIdFromLocalStorage) {
      setStaffId(staffIdFromLocalStorage);
    }
    if (staffIdFromLocalStorage) {
      const fetchUserTodayBookings = async () => {
        setIsLoaded(true);

        try {
          const response = await axios.post(
            `${BaseUrl}/backend/api/dashboard.php`,
            {
              action: "allBookingUser",
              client_id: staffIdFromLocalStorage,
            }
          );

          setAllBookingUserToday(response.data.today_booking_count);
        } catch (error) {
          console.error("Error fetching upcoming bookings:", error);
        }  finally {
          setIsLoaded(false);
        }
    
      };

      fetchUserTodayBookings();
    }
  }, []);

  useEffect(() => {
    setIsLoaded(true);

    // Retrieve staff_id from localStorage
    const staffIdFromLocalStorage = sessionStorage.getItem("userId");
    if (staffIdFromLocalStorage) {
      setStaffId(staffIdFromLocalStorage);
    }
    if (staffIdFromLocalStorage) {
      const fetchUserFutureBookings = async () => {
        setIsLoaded(true);

        try {
          const response = await axios.post(
            `${BaseUrl}/backend/api/dashboard.php`,
            {
              action: "allBookingUser",
              client_id: staffIdFromLocalStorage,
            }
          );

          setAllBookingUserFuture(response.data.upcoming_booking_count);
        } catch (error) {
          console.error("Error fetching upcoming bookings:", error);
        }  finally {
          setIsLoaded(false);
        }
    
      };

      fetchUserFutureBookings();
    }
  }, []);

  // Animation state
  // Hover states for cards
  const [hoveredCard, setHoveredCard] = useState(null);

  // Mimic data changing over time
  // useEffect(() => {
  //   // Set animation loaded state
  //   setTimeout(() => setIsLoaded(true), 300);
  // }, []);

  // Custom styles
  const cardStyle = "bg-white rounded-lg shadow-md transition-all duration-300";
  const iconBoxStyle = "flex items-center justify-center w-8 h-8 rounded-full";
  const LargeMetricCard = ({ title, value, icon, className }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <div
        className={`p-6 rounded-lg shadow-sm flex items-center justify-between transition-transform duration-300 ${className} ${
          isHovered ? "transform scale-102 shadow-md" : ""
        } animate-slideInRight border border-gray-200`} // Added border class
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div>
          <div className="text-sm mb-1">{title}</div>
          <div className="text-2xl font-bold animate-countUp">{value}</div>
        </div>
        <div
          className={`p-3 rounded-full transition-transform duration-300 ${
            isHovered ? "scale-110" : ""
          }`}
        >
          {icon}
        </div>
      </div>
    );
  };

  return (
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {isLoaded && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
    <div className="bg-gray-50 min-h-screen">
      {/* Custom CSS for animations */}
      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes growWidth {
          from {
            width: 0;
          }
          to {
            width: 100%;
          }
        }

        @keyframes pulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
          100% {
            transform: scale(1);
          }
        }

        @keyframes float {
          0% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-8px);
          }
          100% {
            transform: translateY(0px);
          }
        }

        @keyframes shimmer {
          0% {
            background-position: -1000px 0;
          }
          100% {
            background-position: 1000px 0;
          }
        }

        .shimmer-effect {
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 0.2),
            rgba(255, 255, 255, 0)
          );
          background-size: 1000px 100%;
          animation: shimmer 2s infinite linear;
        }

        .fade-in-up {
          opacity: 0;
          animation: fadeInUp 0.6s cubic-bezier(0.215, 0.61, 0.355, 1) forwards;
        }

        .grow-bar {
          animation: growWidth 1.2s cubic-bezier(0.19, 1, 0.22, 1) forwards;
        }

        .pulse-animation {
          animation: pulse 2s infinite ease-in-out;
        }

        .float-animation {
          animation: float 6s infinite ease-in-out;
        }

        .blur-in {
          filter: blur(8px);
          opacity: 0;
          transition: all 0.5s ease-out;
        }

        .blur-in.active {
          filter: blur(0);
          opacity: 1;
        }

        .delay-100 {
          animation-delay: 0.1s;
        }
        .delay-200 {
          animation-delay: 0.2s;
        }
        .delay-300 {
          animation-delay: 0.3s;
        }
        .delay-400 {
          animation-delay: 0.4s;
        }
        .delay-500 {
          animation-delay: 0.5s;
        }

        .hover-card {
          transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }

        .hover-card:hover {
          transform: translateY(-8px) scale(1.02);
          box-shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.1);
        }

        .glow-effect {
          position: relative;
          overflow: hidden;
        }

        .glow-effect::before {
          content: "";
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(
            circle,
            rgba(255, 255, 255, 0.3) 0%,
            rgba(255, 255, 255, 0) 70%
          );
          opacity: 0;
          transition: opacity 0.5s ease;
          pointer-events: none;
        }

        .glow-effect:hover::before {
          opacity: 1;
        }

        .action-button {
          transition: all 0.2s ease;
          transform-origin: center;
        }

        .action-button:hover {
          transform: scale(1.2);
        }

        .line-grow {
          transition: width 0.3s ease, transform 0.3s ease;
          width: 0;
          height: 2px;
        }

        .nav-item:hover .line-grow {
          width: 100%;
        }

        .scale-in-center {
          transform: scale(0);
          opacity: 0;
          transition: all 0.4s cubic-bezier(0.785, 0.135, 0.15, 0.86);
        }

        .scale-in-center.active {
          transform: scale(1);
          opacity: 1;
        }

        .table-row {
          transition: all 0.2s ease;
        }

        .table-row:hover {
          transform: translateX(5px);
        }
      `}</style>

      {/* Main content */}
      <main className="p-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-800 mb-2">
            Welcome to MegaClean
          </h1>
          <p className="text-gray-600">
            Track your cleaning services, appointments, and rewards
          </p>
        </div>

        {/* Stats cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
          <div
            className={`${cardStyle} ${
              isLoaded ? "fade-in-up" : ""
            } hover-card overflow-hidden glow-effect`}
            onMouseEnter={() => setHoveredCard(0)}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div className="p-5">
              <div className="flex items-center justify-between mb-3">
                <span className="text-sm font-medium text-gray-500">
                  Total Services
                </span>
                <div
                  className={`${iconBoxStyle} bg-cyan-100 ${
                    hoveredCard === 0 ? "pulse-animation" : ""
                  }`}
                >
                  <Home className="w-4 h-4 text-cyan-600" />
                </div>
              </div>
              {/* Use the dynamic service count here */}
              <h2 className="text-2xl font-bold text-gray-800 mb-4">
                {ServiceCount}
              </h2>
            </div>
            <div className="h-1.5 w-full bg-gradient-to-r from-cyan-400 to-cyan-500 mt-8"></div>
          </div>

          <div
            className={`${cardStyle} ${
              isLoaded ? "fade-in-up delay-100" : ""
            } hover-card overflow-hidden glow-effect`}
            onMouseEnter={() => setHoveredCard(1)}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div className="p-5">
              <div className="flex items-center justify-between mb-3">
                <span className="text-sm font-medium text-gray-500">
                  Available Services
                </span>
                <div
                  className={`${iconBoxStyle} bg-purple-100 ${
                    hoveredCard === 1 ? "pulse-animation" : ""
                  }`}
                >
                  <Calendar className="w-4 h-4 text-purple-600" />
                </div>
              </div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">
                {ServiceCountAvailable}
              </h2>
            </div>
            <div className="h-1.5 w-full bg-gradient-to-r from-purple-400 to-purple-500 mt-8"></div>
          </div>

          <div
            className={`${cardStyle} ${
              isLoaded ? "fade-in-up delay-200" : ""
            } hover-card overflow-hidden glow-effect`}
            onMouseEnter={() => setHoveredCard(2)}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div className="p-5">
              <div className="flex items-center justify-between mb-3">
                <span className="text-sm font-medium text-gray-500">
                  Total Booking
                </span>
                <div
                  className={`${iconBoxStyle} bg-green-100 ${
                    hoveredCard === 2 ? "pulse-animation" : ""
                  }`}
                >
                  <Star className="w-4 h-4 text-green-600" />
                </div>
              </div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">
                {AllBookingUser}
              </h2>
            </div>
            <div className="h-1.5 w-full bg-gradient-to-r from-green-400 to-green-500 mt-8"></div>
          </div>

          <div
            className={`${cardStyle} ${
              isLoaded ? "fade-in-up delay-300" : ""
            } hover-card overflow-hidden glow-effect`}
            onMouseEnter={() => setHoveredCard(3)}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div className="p-5">
              <div className="flex items-center justify-between mb-3">
                <span className="text-sm font-medium text-gray-500">
                  Total Complete Booking
                </span>
                <div
                  className={`${iconBoxStyle} bg-yellow-100 ${
                    hoveredCard === 3 ? "pulse-animation" : ""
                  }`}
                >
                  <TbCheckupList
                    size={40}
                    className="w-6 h-6 text-yellow-600"
                  />
                </div>
              </div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">
                {CompleteBookingUser}
              </h2>
            </div>
            <div className="h-1.5 w-full bg-gradient-to-r from-yellow-400 to-yellow-500 mt-8"></div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
          <LargeMetricCard
            title="Today Appointment"
            value={AllBookingUserToday || (<span className="text-xl">Sorry Today Appointment Not Available...</span>)}
            icon={<FaClipboardList size={24} className="text-white" />}
            className="bg-blue-800 text-white hover:scale-105 "
          />
          <LargeMetricCard
            title="Future Appointment"
            value={AllBookingUserFuture || (<span className="text-xl">Sorry Future Appointment Not Available...</span>)}
            icon={<LuPcCase size={24} className="text-blue-800" />}
            className="bg-white text-gray-800 hover:scale-105"
          />
          <LargeMetricCard
            title="Total Orders"
            value={ AllBookingUser}
            icon={<Package size={24} className="text-white" />}
            className="bg-gray-600 text-white hover:scale-105" // Fixed incorrect class
          />
        </div>

        {/* Charts Section */}
        <div className="grid grid-cols-1 lg:grid-cols-4 lg:gap-4 mb-10 ">
          {/* Line Chart */}
          <div
            className={`${cardStyle} ${
              isLoaded ? "fade-in-up" : ""
            } col-span-1 lg:col-span-2 overflow-hidden hover-card glow-effect`}
          >
            <div className="p-4 bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-t-lg">
              <div className="flex justify-between items-center">
                <h3 className="font-medium">Services History</h3>
                <span className="text-xs bg-cyan-700/50 backdrop-blur-sm px-2 py-1 rounded-md transition-all duration-300 hover:bg-cyan-800 cursor-pointer hover:scale-105 hover:shadow-md">
                  6 Months
                </span>
              </div>
            </div>
            <div className="p-4 pt-6 h-64 float-animation">
              <ResponsiveContainer width="100%" height="100%">
                <LineChart data={serviceHistoryData}>
                  <CartesianGrid
                    strokeDasharray="3 3"
                    vertical={false}
                    stroke="#f0f0f0"
                  />
                  <XAxis dataKey="name" axisLine={false} tickLine={false} />
                  <YAxis axisLine={false} tickLine={false} />
                  <Tooltip
                    contentStyle={{
                      backgroundColor: "#fff",
                      borderRadius: "0.5rem",
                      boxShadow:
                        "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                      border: "none",
                    }}
                  />
                  <Line
                    type="monotone"
                    dataKey="value"
                    stroke="#0891b2"
                    strokeWidth={3}
                    dot={false}
                    activeDot={{
                      r: 8,
                      stroke: "#0891b2",
                      strokeWidth: 2,
                      fill: "#fff",
                    }}
                    animationDuration={1500}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
            <div className="p-4 border-t border-gray-100 backdrop-blur-sm">
              <div className="flex justify-between">
                <div className="transition-all duration-300 hover:scale-105">
                  <p className="text-lg font-bold bg-gradient-to-r from-cyan-600 to-cyan-400 bg-clip-text text-transparent">
                    15
                  </p>
                  <p className="text-xs text-gray-500">Total Services</p>
                </div>
                <div className="transition-all duration-300 hover:scale-105">
                  <p className="text-lg font-bold bg-gradient-to-r from-green-600 to-green-400 bg-clip-text text-transparent">
                    3
                  </p>
                  <p className="text-xs text-gray-500">This Month</p>
                </div>
              </div>
              <div className="flex mt-4 text-xs">
                <div className="mr-4 flex items-center transition-all duration-300 hover:scale-105 hover:text-red-600">
                  <span className="text-gray-500 mr-1">Last Month</span>
                  <span className="text-red-500 flex items-center">
                    -1 <ArrowDown className="h-3 w-3" />
                  </span>
                </div>
                <div className="flex items-center transition-all duration-300 hover:scale-105 hover:text-green-600">
                  <span className="text-gray-500 mr-1">Year to Date</span>
                  <span className="text-green-500 flex items-center">
                    +8 <ArrowUp className="h-3 w-3" />
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Pie Chart */}
           {/* Pie Chart */}
           <div
            className={`${cardStyle} ${
              isLoaded ? "fade-in-up delay-100 mt-6 lg:mt-0" : ""
            } p-5 col-span-12 lg:col-span-2 hover-card glow-effect`}
          >
            <h3 className="font-medium mb-4 relative inline-block">
              Service Breakdown
              <div className="line-grow bg-cyan-500 absolute bottom-0 left-0"></div>
            </h3>
            <div className="flex flex-col md:flex-row">
              <div className="w-full md:w-1/2 h-64">
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={setall} // Use setall instead of pieData
                      cx="50%"
                      cy="50%"
                      innerRadius={60}
                      outerRadius={80}
                      paddingAngle={5}
                      dataKey="value"
                      animationDuration={1000}
                      animationBegin={400}
                    >
                      {setall?.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={entry.color} // Use the dynamically generated color
                        />
                      ))}
                    </Pie>
                    <Tooltip
                      contentStyle={{
                        backgroundColor: "#fff",
                        borderRadius: "0.5rem",
                        boxShadow:
                          "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                        border: "none",
                      }}
                    />
                  </PieChart>
                </ResponsiveContainer>
              </div>
              <div className="w-full md:w-1/2 mt-4 md:mt-0">
                {serviceBreakdown.map((item, index) => (
                  <div
                    key={index}
                    className={`mb-3 ${
                      isLoaded ? "fade-in-up" : ""
                    } transition-all duration-300 hover:scale-105`}
                    style={{ animationDelay: `${0.5 + index * 0.1}s` }}
                  >
                    <div className="flex justify-between text-sm mb-1">
                      <span>{item.type}</span>
                      <span>{item.percentage}%</span>
                    </div>
                    <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                      <div
                        className="h-full bg-gradient-to-r from-cyan-400 to-cyan-600 grow-bar"
                        style={{
                          width: "100%",
                          transformOrigin: "left",
                          transform: `scaleX(${item.percentage / 100})`,
                          animationDelay: `${0.7 + index * 0.1}s`,
                        }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* Your loyalty stats */}
          </div>

        </div>
      </main>
    </div>
    </div>
  );
};

export default UserDashboard;

// import React, { useState, useEffect } from 'react';
// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
// import { Search, Bell, User, ChevronDown, Download, ArrowUp, ArrowDown, ExternalLink, Edit, Trash, Calendar, Clock, Home, Star, CreditCard } from 'lucide-react';

// const UserDashboard = () => {
//   // Sample data for the charts
//   const [serviceHistoryData, setServiceHistoryData] = useState([
//     { name: 'Jan', value: 2 },
//     { name: 'Feb', value: 3 },
//     { name: 'Mar', value: 1 },
//     { name: 'Apr', value: 4 },
//     { name: 'May', value: 2 },
//     { name: 'Jun', value: 3 },
//   ]);

//   const pieData = [
//     { name: 'Home Cleaning', value: 45, color: '#f87171' },
//     { name: 'Office Cleaning', value: 30, color: '#60a5fa' },
//     { name: 'Carpet Cleaning', value: 25, color: '#34d399' },
//   ];

//   const serviceBreakdown = [
//     { type: 'Home Cleaning', percentage: 45 },
//     { type: 'Office Cleaning', percentage: 30 },
//     { type: 'Carpet Cleaning', percentage: 15 },
//     { type: 'Window Cleaning', percentage: 10 },
//   ];

//   const upcomingAppointments = [
//     { id: '001', service: 'Home Deep Cleaning', address: '123 Main St, Apt 4B', date: '18-03-2025', time: '09:00 AM', status: 'Confirmed', provider: 'John Smith' },
//     { id: '002', service: 'Office Weekly Clean', address: '456 Business Ave, Suite 300', date: '21-03-2025', time: '08:30 AM', status: 'Pending', provider: 'Maria Johnson' },
//     { id: '003', service: 'Carpet Cleaning', address: '123 Main St, Apt 4B', date: '25-03-2025', time: '10:00 AM', status: 'Scheduled', provider: 'David Wilson' },
//   ];

//   const loyaltyStats = [
//     { milestone: 'Silver', services: '5 services', color: 'bg-gray-400' },
//     { milestone: 'Gold', services: '10 services', color: 'bg-yellow-500' },
//     { milestone: 'Platinum', services: '25 services', color: 'bg-blue-500' },
//   ];

//   const COLORS = ['#f87171', '#60a5fa', '#34d399'];

//   // Animation state
//   const [isLoaded, setIsLoaded] = useState(false);
//   // Hover states for cards
//   const [hoveredCard, setHoveredCard] = useState(null);

//   // Mimic data changing over time
//   useEffect(() => {
//     // Set animation loaded state
//     setTimeout(() => setIsLoaded(true), 300);
//   }, []);

//   // Custom styles
//   const cardStyle = "bg-white rounded-xl shadow-lg transition-all duration-300 border border-gray-100";
//   const buttonStyle = "text-white text-xs font-medium py-2 px-4 rounded-lg transition-all duration-200 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-opacity-50";
//   const iconBoxStyle = "flex items-center justify-center w-10 h-10 rounded-xl";

//   return (
//     <div className="bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen">
//       {/* Custom CSS for animations */}
//       <style jsx>{`
//         @keyframes fadeInUp {
//           from {
//             opacity: 0;
//             transform: translateY(30px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         @keyframes growWidth {
//           from { width: 0; }
//           to { width: 100%; }
//         }

//         @keyframes pulse {
//           0% { transform: scale(1); }
//           50% { transform: scale(1.05); }
//           100% { transform: scale(1); }
//         }

//         @keyframes float {
//           0% { transform: translateY(0px); }
//           50% { transform: translateY(-8px); }
//           100% { transform: translateY(0px); }
//         }

//         @keyframes shimmer {
//           0% { background-position: -1000px 0; }
//           100% { background-position: 1000px 0; }
//         }

//         .shimmer-effect {
//           background: linear-gradient(90deg, rgba(255,255,255,0), rgba(255,255,255,0.2), rgba(255,255,255,0));
//           background-size: 1000px 100%;
//           animation: shimmer 2s infinite linear;
//         }

//         .fade-in-up {
//           opacity: 0;
//           animation: fadeInUp 0.6s cubic-bezier(0.215, 0.61, 0.355, 1) forwards;
//         }

//         .grow-bar {
//           animation: growWidth 1.2s cubic-bezier(0.19, 1, 0.22, 1) forwards;
//         }

//         .pulse-animation {
//           animation: pulse 2s infinite ease-in-out;
//         }

//         .float-animation {
//           animation: float 6s infinite ease-in-out;
//         }

//         .blur-in {
//           filter: blur(8px);
//           opacity: 0;
//           transition: all 0.5s ease-out;
//         }

//         .blur-in.active {
//           filter: blur(0);
//           opacity: 1;
//         }

//         .delay-100 { animation-delay: 0.1s; }
//         .delay-200 { animation-delay: 0.2s; }
//         .delay-300 { animation-delay: 0.3s; }
//         .delay-400 { animation-delay: 0.4s; }
//         .delay-500 { animation-delay: 0.5s; }

//         .hover-card {
//           transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
//         }

//         .hover-card:hover {
//           transform: translateY(-8px) scale(1.02);
//           box-shadow: 0 20px 30px -10px rgba(0, 0, 0, 0.1);
//         }

//         .glow-effect {
//           position: relative;
//           overflow: hidden;
//         }

//         .glow-effect::before {
//           content: '';
//           position: absolute;
//           top: -50%;
//           left: -50%;
//           width: 200%;
//           height: 200%;
//           background: radial-gradient(circle, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0) 70%);
//           opacity: 0;
//           transition: opacity 0.5s ease;
//           pointer-events: none;
//           z-index: 1;
//         }

//         .glow-effect:hover::before {
//           opacity: 1;
//         }

//         .action-button {
//           transition: all 0.2s ease;
//           transform-origin: center;
//         }

//         .action-button:hover {
//           transform: scale(1.2);
//         }

//         .line-grow {
//           transition: width 0.6s ease, transform 0.3s ease;
//           width: 0;
//           height: 3px;
//           border-radius: 2px;
//         }

//         .nav-item:hover .line-grow, .section-title:hover .line-grow {
//           width: 100%;
//         }

//         .scale-in-center {
//           transform: scale(0);
//           opacity: 0;
//           transition: all 0.4s cubic-bezier(0.785, 0.135, 0.15, 0.86);
//         }

//         .scale-in-center.active {
//           transform: scale(1);
//           opacity: 1;
//         }

//         .table-row {
//           transition: all 0.3s ease;
//         }

//         .table-row:hover {
//           transform: translateX(5px);
//           background-color: rgba(6, 182, 212, 0.05);
//         }

//         .service-card {
//           backdrop-filter: blur(5px);
//           transition: all 0.3s ease;
//         }

//         .service-card:hover {
//           backdrop-filter: blur(10px);
//         }

//         .gradient-text {
//           background-clip: text;
//           -webkit-background-clip: text;
//           color: transparent;
//           background-image: linear-gradient(to right, #0891b2, #0ea5e9);
//         }

//         .glass-effect {
//           background: rgba(255, 255, 255, 0.8);
//           backdrop-filter: blur(10px);
//           border: 1px solid rgba(255, 255, 255, 0.2);
//         }

//         .progress-bar {
//           position: relative;
//           overflow: hidden;
//         }

//         .progress-bar:after {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           height: 100%;
//           width: 30px;
//           background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.8), transparent);
//           animation: shimmer 2s infinite;
//         }
//       `}</style>

//       {/* Main content */}
//       <main className="p-8">
//         <div className="mb-8 glass-effect p-6 rounded-2xl shadow-md">
//           <h1 className="text-3xl font-bold text-blue-600 mb-2">Welcome to MegaClean</h1>
//           <p className="text-gray-600">Track your cleaning services, appointments, and rewards</p>
//         </div>

//         {/* Stats cards */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
//           <div
//             className={`${cardStyle} ${isLoaded ? 'fade-in-up' : ''} hover-card overflow-hidden glow-effect`}
//             onMouseEnter={() => setHoveredCard(0)}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <div className="p-6">
//               <div className="flex items-center justify-between mb-4">
//                 <span className="text-sm font-medium text-gray-500">Total Services</span>
//                 <div className={`${iconBoxStyle} bg-cyan-100 ${hoveredCard === 0 ? 'pulse-animation' : ''}`}>
//                   <Home className="w-5 h-5 text-cyan-600" />
//                 </div>
//               </div>
//               <h2 className="text-3xl font-bold text-gray-800 mb-4">15</h2>
//             </div>
//             <div className="h-2 w-full bg-gradient-to-r from-cyan-400 to-cyan-500"></div>
//           </div>

//           <div
//             className={`${cardStyle} ${isLoaded ? 'fade-in-up delay-100' : ''} hover-card overflow-hidden glow-effect`}
//             onMouseEnter={() => setHoveredCard(1)}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <div className="p-6">
//               <div className="flex items-center justify-between mb-4">
//                 <span className="text-sm font-medium text-gray-500">Upcoming Services</span>
//                 <div className={`${iconBoxStyle} bg-purple-100 ${hoveredCard === 1 ? 'pulse-animation' : ''}`}>
//                   <Calendar className="w-5 h-5 text-purple-600" />
//                 </div>
//               </div>
//               <h2 className="text-3xl font-bold text-gray-800 mb-4">3</h2>
//             </div>
//             <div className="h-2 w-full bg-gradient-to-r from-purple-400 to-purple-500"></div>
//           </div>

//           <div
//             className={`${cardStyle} ${isLoaded ? 'fade-in-up delay-200' : ''} hover-card overflow-hidden glow-effect`}
//             onMouseEnter={() => setHoveredCard(2)}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <div className="p-6">
//               <div className="flex items-center justify-between mb-4">
//                 <span className="text-sm font-medium text-gray-500">Reward Points</span>
//                 <div className={`${iconBoxStyle} bg-green-100 ${hoveredCard === 2 ? 'pulse-animation' : ''}`}>
//                   <Star className="w-5 h-5 text-green-600" />
//                 </div>
//               </div>
//               <h2 className="text-3xl font-bold text-gray-800 mb-4">850</h2>
//             </div>
//             <div className="h-2 w-full bg-gradient-to-r from-green-400 to-green-500"></div>
//           </div>

//           <div
//             className={`${cardStyle} ${isLoaded ? 'fade-in-up delay-300' : ''} hover-card overflow-hidden glow-effect`}
//             onMouseEnter={() => setHoveredCard(3)}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <div className="p-6">
//               <div className="flex items-center justify-between mb-4">
//                 <span className="text-sm font-medium text-gray-500">Saved Money</span>
//                 <div className={`${iconBoxStyle} bg-yellow-100 ${hoveredCard === 3 ? 'pulse-animation' : ''}`}>
//                   <CreditCard className="w-5 h-5 text-yellow-600" />
//                 </div>
//               </div>
//               <h2 className="text-3xl font-bold text-gray-800 mb-4">$125</h2>
//             </div>
//             <div className="h-2 w-full bg-gradient-to-r from-yellow-400 to-yellow-500"></div>
//           </div>
//         </div>

//         {/* Charts Section */}
//         <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 mb-8">
//           {/* Line Chart */}
//           <div className={`${cardStyle} ${isLoaded ? 'fade-in-up' : ''} col-span-1 lg:col-span-2 overflow-hidden hover-card glow-effect`}>
//             <div className="p-5 bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-t-xl">
//               <div className="flex justify-between items-center">
//                 <h3 className="font-medium text-lg">Services History</h3>
//                 <span className="text-xs bg-cyan-700/50 backdrop-blur-sm px-3 py-1 rounded-full transition-all duration-300 hover:bg-cyan-800 cursor-pointer hover:scale-105 hover:shadow-md">6 Months</span>
//               </div>
//             </div>
//             <div className="p-6 pt-8 h-64 float-animation">
//               <ResponsiveContainer width="100%" height="100%">
//                 <LineChart data={serviceHistoryData}>
//                   <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
//                   <XAxis dataKey="name" axisLine={false} tickLine={false} />
//                   <YAxis axisLine={false} tickLine={false} />
//                   <Tooltip
//                     contentStyle={{
//                       backgroundColor: '#fff',
//                       borderRadius: '1rem',
//                       boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
//                       border: 'none'
//                     }}
//                   />
//                   <Line
//                     type="monotone"
//                     dataKey="value"
//                     stroke="#0891b2"
//                     strokeWidth={4}
//                     dot={false}
//                     activeDot={{ r: 8, stroke: '#0891b2', strokeWidth: 2, fill: '#fff' }}
//                     animationDuration={1500}
//                   />
//                 </LineChart>
//               </ResponsiveContainer>
//             </div>
//             <div className="p-6 border-t border-gray-100 backdrop-blur-sm bg-white/70">
//               <div className="flex justify-between">
//                 <div className="transition-all duration-300 hover:scale-105">
//                   <p className="text-2xl font-bold bg-gradient-to-r from-cyan-600 to-cyan-400 bg-clip-text text-transparent">15</p>
//                   <p className="text-xs text-gray-500">Total Services</p>
//                 </div>
//                 <div className="transition-all duration-300 hover:scale-105">
//                   <p className="text-2xl font-bold bg-gradient-to-r from-green-600 to-green-400 bg-clip-text text-transparent">3</p>
//                   <p className="text-xs text-gray-500">This Month</p>
//                 </div>
//               </div>
//               <div className="flex mt-4 text-xs">
//                 <div className="mr-4 flex items-center transition-all duration-300 hover:scale-105 hover:text-red-600">
//                   <span className="text-gray-500 mr-1">Last Month</span>
//                   <span className="text-red-500 flex items-center">-1 <ArrowDown className="h-3 w-3" /></span>
//                 </div>
//                 <div className="flex items-center transition-all duration-300 hover:scale-105 hover:text-green-600">
//                   <span className="text-gray-500 mr-1">Year to Date</span>
//                   <span className="text-green-500 flex items-center">+8 <ArrowUp className="h-3 w-3" /></span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Pie Chart */}
//           <div className={`${cardStyle} ${isLoaded ? 'fade-in-up delay-100' : ''} p-6 col-span-1 lg:col-span-2 hover-card glow-effect`}>
//             <h3 className="font-medium text-lg mb-5 relative inline-block section-title">
//               Service Breakdown
//               <div className="line-grow bg-cyan-500 absolute bottom-0 left-0"></div>
//             </h3>
//             <div className="flex flex-col md:flex-row">
//               <div className="w-full md:w-1/2 h-64">
//                 <ResponsiveContainer width="100%" height="100%" className="float-animation">
//                   <PieChart>
//                     <Pie
//                       data={pieData}
//                       cx="50%"
//                       cy="50%"
//                       innerRadius={60}
//                       outerRadius={80}
//                       paddingAngle={5}
//                       dataKey="value"
//                       animationDuration={1000}
//                       animationBegin={400}
//                     >
//                       {pieData.map((entry, index) => (
//                         <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                       ))}
//                     </Pie>
//                     <Tooltip
//                       contentStyle={{
//                         backgroundColor: '#fff',
//                         borderRadius: '1rem',
//                         boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
//                         border: 'none'
//                       }}
//                     />
//                   </PieChart>
//                 </ResponsiveContainer>
//               </div>
//               <div className="w-full md:w-1/2 mt-4 md:mt-0">
//                 {serviceBreakdown.map((item, index) => (
//                   <div key={index} className={`mb-4 ${isLoaded ? 'fade-in-up' : ''} transition-all duration-300 hover:scale-105`} style={{ animationDelay: `${0.5 + index * 0.1}s` }}>
//                     <div className="flex justify-between text-sm mb-2">
//                       <span className="font-medium">{item.type}</span>
//                       <span className="font-bold">{item.percentage}%</span>
//                     </div>
//                     <div className="h-3 bg-gray-200 rounded-full overflow-hidden progress-bar">
//                       <div
//                         className="h-full bg-gradient-to-r from-cyan-400 to-cyan-600 grow-bar"
//                         style={{
//                           width: '100%',
//                           transformOrigin: 'left',
//                           transform: `scaleX(${item.percentage / 100})`,
//                           animationDelay: `${0.7 + index * 0.1}s`
//                         }}
//                       ></div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//             <div className="flex justify-between mt-6 border-t border-gray-100 pt-4">
//               {loyaltyStats.map((level, index) => (
//                 <div key={index} className="text-center cursor-pointer transition-all duration-300 hover:scale-110 hover:shadow-lg p-2 rounded-lg">
//                   <h4 className="font-medium text-sm">{level.milestone}</h4>
//                   <div className={`inline-block ${level.color} w-10 h-1.5 my-2 rounded-full`}></div>
//                   <p className="text-xs text-gray-500">{level.services}</p>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Loyalty Program */}
//           <div className={`${cardStyle} ${isLoaded ? 'fade-in-up delay-200' : ''} p-6 hover-card glow-effect`}>
//             <h3 className="font-medium text-lg mb-5 relative inline-block section-title">
//               Loyalty Program
//               <div className="line-grow bg-cyan-500 absolute bottom-0 left-0"></div>
//             </h3>
//             <div className="mb-6">
//               <p className="text-sm text-gray-600 mb-2">Current Status</p>
//               <div className="bg-yellow-100 text-yellow-800 font-medium py-2 px-4 rounded-lg text-center text-sm border border-yellow-200">
//                 Gold Member
//               </div>
//             </div>

//             <div className="mb-6">
//               <p className="text-sm text-gray-600 mb-2">Progress to Platinum</p>
//               <div className="h-4 bg-gray-200 rounded-full overflow-hidden mb-2 progress-bar">
//                 <div
//                   className="h-full bg-gradient-to-r from-yellow-400 to-blue-500 grow-bar"
//                   style={{
//                     width: '100%',
//                     transformOrigin: 'left',
//                     transform: 'scaleX(0.6)',
//                   }}
//                 ></div>
//               </div>
//               <p className="text-xs text-gray-500 text-right">15 of 25 services</p>
//             </div>

//             <div className="mb-2">
//               <p className="text-sm text-gray-600 mb-3">Available Rewards</p>
//               <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-lg p-4 mb-3 text-sm hover:shadow-md transition-all duration-300 cursor-pointer border border-gray-200">
//                 <p className="font-medium">25% Off Deep Clean</p>
//                 <p className="text-xs text-gray-500 mt-1">Use code: GOLD25</p>
//               </div>
//               <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-lg p-4 text-sm hover:shadow-md transition-all duration-300 cursor-pointer border border-gray-200">
//                 <p className="font-medium">Free Window Cleaning</p>
//                 <p className="text-xs text-gray-500 mt-1">Next home service</p>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Upcoming Appointments Table */}
//         <div className={`${cardStyle} ${isLoaded ? 'fade-in-up delay-300' : ''} mb-6 overflow-hidden hover-card`}>
//           <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-gray-50 to-white">
//             <h3 className="font-medium text-lg relative inline-block section-title">
//               Upcoming Appointments
//               <div className="line-grow bg-cyan-500 absolute bottom-0 left-0"></div>
//             </h3>
//           </div>
//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead>
//                 <tr className="text-xs text-gray-500 border-b border-gray-100 bg-gray-50">
//                   <th className="px-6 py-4 text-left">Service</th>
//                   <th className="px-6 py-4 text-left">Address</th>
//                   <th className="px-6 py-4 text-left">Date</th>
//                   <th className="px-6 py-4 text-left">Time</th>
//                   <th className="px-6 py-4 text-left">Service Provider</th>
//                   <th className="px-6 py-4 text-left">Status</th>
//                   <th className="px-6 py-4 text-left">Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {upcomingAppointments.map((appointment, index) => (
//                   <tr
//                     key={appointment.id}
//                     className={`border-b border-gray-100 text-sm transition-all duration-300 hover:bg-cyan-50 table-row ${isLoaded ? 'fade-in-up' : ''}`}
//                     style={{ animationDelay: `${0.8 + index * 0.1}s` }}
//                   >
//                     <td className="px-6 py-4 font-medium">{appointment.service}</td>
//                     <td className="px-6 py-4 text-gray-500">{appointment.address}</td>
//                     <td className="px-6 py-4">{appointment.date}</td>
//                     <td className="px-6 py-4">{appointment.time}</td>
//                     <td className="px-6 py-4">{appointment.provider}</td>
//                     <td className="px-6 py-4">
//                       <span className={`text-xs px-3 py-1 rounded-full transition-all duration-300 ${
//                         appointment.status === 'Confirmed' ? 'bg-green-100 text-green-800 hover:bg-green-200 hover:shadow-md border border-green-200' :
//                         appointment.status === 'Pending' ? 'bg-yellow-100 text-yellow-800 hover:bg-yellow-200 hover:shadow-md border border-yellow-200' :
//                         'bg-blue-100 text-blue-800 hover:bg-blue-200 hover:shadow-md border border-blue-200'
//                       }`}>
//                         {appointment.status}
//                       </span>
//                     </td>
//                     <td className="px-6 py-4">
//                       <div className="flex space-x-3">
//                         <button className="text-cyan-500 hover:text-cyan-700 transition-all duration-300 p-1.5 hover:bg-cyan-100 rounded-full action-button">
//                           <Edit className="h-4 w-4" />
//                         </button>
//                         <button className="text-red-500 hover:text-red-700 transition-all duration-300 p-1.5 hover:bg-red-100 rounded-full action-button">
//                           <Trash className="h-4 w-4" />
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <div className="p-6 text-center">
//             <button className="bg-gradient-to-r from-cyan-500 to-cyan-600 hover:from-cyan-600 hover:to-cyan-700 text-white px-6 py-3 rounded-lg transition-all duration-300 text-sm font-medium shadow-lg hover:shadow-xl">
//               Schedule New Service
//             </button>
//           </div>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default UserDashboard;
